// extracted by mini-css-extract-plugin
module.exports = {"title":"GridView_title__GViX1","row":"GridView_row__jGDLX","vehicles":"GridView_vehicles__EEJRc","vehicleCard":"GridView_vehicleCard__LT1Ty"};